document.addEventListener("DOMContentLoaded", () => {
  // ----------------------------- Megamenu JS - Start -----------------------------
  const menuItems = document.querySelectorAll(
    ".mega-menu .childlink_list_item > a"
  );

  menuItems.forEach((item) => {
    item.addEventListener("mouseover", (e) => {
      const submenu = item.nextElementSibling;

      if (submenu && submenu.classList.contains("childlink_list")) {
        e.preventDefault();

        const allSubmenus = document.querySelectorAll(".childlink_list");

        allSubmenus.forEach((menu) => {
          if (menu !== submenu) {
            menu.classList.remove("active");
          }
        });

        submenu.classList.add("active");
      } else {
        const allSubmenus2 = document.querySelectorAll(".childlink_list");
        allSubmenus2.forEach((menu) => {
          if (menu !== submenu) {
            menu.classList.remove("active");
          }
        });
      }
    });
  });
  // ----------------------------- Megamenu JS - End -----------------------------

  // ----------------------------- MenuDrawer JS - Start -----------------------------
  // Open First Menu By Default In Menu Drawer
  const firstLi = document.querySelector(
    ".drawer__menu > li:first-child details"
  );

  document.querySelector(".header").addEventListener("click", function () {
    setTimeout(function () {
      const menuDrawer = document.getElementById("MenuDrawer");

      if (menuDrawer && menuDrawer.hasAttribute("open")) {
        if (firstLi && firstLi.querySelector(".drawer__submenu")) {
          firstLi.classList.add("active");
          firstLi.setAttribute("open", "");
        }
      }
    }, 500);
  });
  // ----------------------------- MenuDrawer JS - End -----------------------------

  // ----------------------------- CartDrawer JS - Start -----------------------------
  function refreshCart() {
    const lineItem = document.querySelector("cart-count.count").textContent;
    // const upcell_div_class = document.getElementById("drawer__inner").classList;
    const upcell_div_class = document.querySelector("#drawer__inner").classList;

    if (lineItem == 0) {
      upcell_div_class.add("empty_cart_products");
      document.getElementById("cart_products_recommendations").style.display =
        "block";
    } else {
      upcell_div_class.remove("empty_cart_products");
      document.getElementById("cart_products_recommendations").style.display =
        "none";
    }
  }
  if (!window.location.pathname.includes("/cart")) {
    document.addEventListener("click", () => {
      setTimeout(function () {
        refreshCart();
      }, 2000);

      refreshCart();
    });
  }
  // ----------------------------- CartDrawer JS - End -----------------------------

  // ----------------------------- Image with collapse JS - START -----------------------------
  document
    .querySelectorAll(
      ".cc-image-with-collapse .accordion > .accordion-item.is-active"
    )
    .forEach(function (item) {
      const panel = item.querySelector(".accordion-panel");
      if (panel) {
        panel.style.maxHeight = panel.scrollHeight + "px";
        panel.style.opacity = "1";
      }
    });

  document
    .querySelectorAll(".accordion > .accordion-item")
    .forEach(function (item) {
      item.addEventListener("click", function () {
        const panel = item.querySelector(".accordion-panel");
        const isActive = item.classList.contains("is-active");

        document
          .querySelectorAll(".accordion > .accordion-item")
          .forEach(function (sibling) {
            if (sibling !== item) {
              sibling.classList.remove("is-active");
              const siblingPanel = sibling.querySelector(".accordion-panel");
              if (siblingPanel) {
                siblingPanel.style.maxHeight = "0px";
                siblingPanel.style.opacity = "0";
              }
            }
          });

        item.classList.toggle("is-active");

        if (!isActive) {
          panel.style.maxHeight = panel.scrollHeight + "px";
          panel.style.opacity = "1";
        } else {
          panel.style.maxHeight = "0px";
          panel.style.opacity = "0";
        }
      });
    });
  // ----------------------------- Image with collapse JS - End -----------------------------

  // -----------------------------  Open external links in a new tab - START -----------------------------
  const links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }

  // -----------------------------  Open external links in a new tab - END -----------------------------
});
